module.exports = __webpack_public_path__ + "img/banner_rcp.8dcc7ae.webp";